import { observer } from "mobx-react-lite";
import { usePipedriveStore } from "../..";
import useRowClassName from "../../hooks/useRowClassName";
import IEntityFieldsProps from "../../interfaces/IEntityFieldsProps";
import { CorpOwnership, ITenantInMarketState } from "../../interfaces/ITenantInMarket";
import { corpOwnershipToString } from "../../utils/enumUtils";
import commonStyles from "../Common.module.css";
import editStyles from "../Edit.module.css";
import NumberInput from "../inputs/NumberInput";
import PipedriveCompanyInput from "../inputs/PipedriveCompanyInput";
import SelectInput from "../inputs/SelectInput";
import StringInput from "../inputs/StringInput";
import TextInput from "../inputs/TextInput";

function TenantInMarketFields({ formik, children }: IEntityFieldsProps<ITenantInMarketState>) {
    const pipedriveStore = usePipedriveStore();
    const rowClassName = useRowClassName();

    return (
        <div className={editStyles.container}>
            <div className={editStyles.column}>
                <div className={commonStyles.header}>Details</div>
                <div className={rowClassName}>
                    <StringInput formik={formik} label="DESCRIPTION" name="description" />
                </div>
                <div className={rowClassName}>
                    <div className={editStyles.doubleWidthRowGroup}>
                        <div className={rowClassName}>
                            <NumberInput formik={formik} label="LAND AREA MIN (ACRES)" name="landAreaMin" />
                            <NumberInput formik={formik} label="LAND AREA MAX (ACRES)" name="landAreaMax" />
                        </div>
                        <div className={rowClassName}>
                            <NumberInput formik={formik} label="BUILDING AREA MIN (SQ-FT)" name="buildingAreaMin" />
                            <NumberInput formik={formik} label="BUILDING AREA MAX (SQ-FT)" name="buildingAreaMax" />
                        </div>
                        <div className={rowClassName}>
                            <StringInput formik={formik} label="USE TYPE" name="useType" />
                            <StringInput formik={formik} label="CONTACT" name="contact" />
                        </div>
                    </div>
                    <div className={editStyles.rowGroup}>
                        <div className={rowClassName}>
                            <SelectInput formik={formik} label="ASSIGNED TO" name="assignedToPipedriveUserId" valueAsCorrectType={value => Number(value)}>
                                {pipedriveStore.users.map(u => (
                                    <option key={u.id} value={u.id}>{u.name}</option>
                                ))}
                            </SelectInput>
                        </div>
                        <div className={rowClassName}>
                            <PipedriveCompanyInput formik={formik} label="TENANT" name="pipedriveCompanyName" />
                        </div>
                        <div className={rowClassName}>
                            <PipedriveCompanyInput formik={formik} label="BROKERAGE" name="pipedriveBrokerageName" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={editStyles.column}>
                <div className={commonStyles.header}>&nbsp;</div>
                <div className={rowClassName}>
                    <NumberInput formik={formik} label="TARGET ANNUAL RENT ($)" name="targetAnnualRent" />
                    <StringInput formik={formik} label="ZONING" name="zoningRequired" />
                    <StringInput formik={formik} label="SITE CONDITIONS" name="siteConditions" />
                </div>
                <div className={rowClassName}>
                    <StringInput formik={formik} label="TIMING" name="timing" />
                    <StringInput formik={formik} label="COMPANY WEBSITE" name="companyWebsite" />
                    <SelectInput formik={formik} label="CORP OWNERSHIP" name="corpOwnership" valueAsCorrectType={value => value as CorpOwnership}>
                        <option value={""}>----</option>
                        <option value={CorpOwnership.Public}>{corpOwnershipToString(CorpOwnership.Public)}</option>
                        <option value={CorpOwnership.Private}>{corpOwnershipToString(CorpOwnership.Private)}</option>
                    </SelectInput>
                </div>
                <div className={rowClassName}>
                    <StringInput formik={formik} label="REVENUE" name="revenue" />
                    <NumberInput formik={formik} label="NUMBER OF EMPLOYEES" name="numberOfEmployees" />
                    <NumberInput formik={formik} label="NUMBER OF LOCATIONS" name="numberOfLocations" />
                </div>
                <div className={rowClassName}>
                    <TextInput formik={formik} label="NOTES" name="notes" placeholder="Enter notes..." />
                </div>
                {children}
            </div>
        </div>
    );
}

export default observer(TenantInMarketFields);